import { ApiConfigService as s } from "@nextgen-web-framework/core";
const h = async (t) => {
  const r = s.getBaseUrl(), o = t.url.startsWith("http") ? t.url : `${r}${t.url}`, a = {
    "Content-Type": "application/json",
    ...s.getTuples() || {},
    ...t.headers
  }, c = {
    method: t.method ?? "GET",
    headers: a,
    body: t.body ? JSON.stringify(t.body) : void 0
  }, e = await fetch(o, c);
  if (!e.ok)
    throw new Error(`Fetch Request failed with status ${e.status}`);
  return e.json();
};
export {
  h as request
};
//# sourceMappingURL=fetchRequest.js.map
